<template>
    <div>
        <commonheader :activeNavIdx="parseInt(this.$route.query.currentNavIndex)"></commonheader>
        <div class="content el-container-master">
            <div class="crumbsNavCont">
                <p class="crumbsNav">位置：首页>{{typeName}}</p>
            </div>
            <div class="detail">
                <div class="associationNewDetailCont" v-loading='loading'>
                    <div v-if="Object.keys(newDetailData).length > 0">
                        <h2 class="detailTitle">{{newDetailData.title}}</h2>
                        <p class="publishTime">
                            <span>作者：{{newDetailData.post_author}}</span>
                            <span>来源：{{newDetailData.post_source}}</span>
                            <span>浏览量：{{newDetailData.post_hits}}</span>
                            <span>发布时间: {{newDetailData.published_time}}</span>
                            
                        </p>

                        <div class="paragraphList" v-html="newDetailData.content"></div>
                    </div>
                </div>
                <div class="contactUsBox fr">
                    <contactus :contactStyle2="true"></contactus>
                </div>
            </div>
        </div>
        <commonfooter></commonfooter>
    </div>
</template>

<script>
import commonheader from './common/commonHeader.vue' //头部组件
import commonfooter from './common/commonFooter.vue' //底部组件
import contactus from './common/contactUs.vue' //右侧联系我们组件
import { mapState } from "vuex";
export default {
    name: "index",
    components: {
        commonheader,
        commonfooter,
        contactus,
    },
    data () {
        return {
            loading: true,
            newDetailData: {},
            typeName:'',
        };
    },

    computed: {
        ...mapState({
            navCategoryListData: state => state.index.navCategoryListData,
        }),
    },
    watch: {
        'newDetailData': {
            handler: function (val, oldVal) {
                this.newDetailData = val
            },
            deep: true
        },
    },
    mounted () {
     
        // 1: 协会动态  2.办事指南 3.继续教育 4.新闻资讯  5.药学服务 6.通知公告
        let navCategoryPageParams = {
            postid: this.$route.query.postid
        }
        this.$store.dispatch('navCategoryPage', navCategoryPageParams).then((res) => {
            if (res.code == 200) {
                if (res.data) {
                    this.newDetailData = res.data
                }
            }
            this.loading = false;
        }).catch(error => {
            this.loading = false;
            console.error('错误信息：', error)
        })
        this.getTypeName();
    },
    methods: {
        /**
         * 获取列表类型名称
         */
        getTypeName () {
           let id = this.$route.query.newsId;
            let obj = {
                '1':'协会动态',
                '2':'办事指南',
                '3':'继续教育',
                '4':'新闻资讯',
                '5':'药学服务'
            }
            this.typeName = obj[id];
        },
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (min-width: 1399px) {
    .el-container-master {
        width: 1200px;
        margin: auto;
    }
}
.content {
    margin: 0 auto;
    padding-bottom: 50px;
}
.detail{
    position: relative;
}
.crumbsNavCont {
    height: 70px;
    border-bottom: 1px solid #d8d8d8;
    position: relative;
}
.crumbsNav {
    font-size: 14px;
    color: #222;
    height: 100%;
    line-height: 70px;
}

.associationNewDetailCont {
    width: 880px;
    min-height: 600px;
    overflow: hidden;
}

.detailTitle {
    text-align: center;
    margin-top: 25px;
    font-weight: bold;
    /* width: 70%; */
    margin: 25px auto 0;
    font-size: 18px;
}

.publishTime {
    text-align: center;
    color: #999;
    font-size: 14px;
    margin: 20px 0;
}
.publishTime span{
    padding: 0 10px
}

.paragraphList {
    width: 100%;
    margin: 0 auto;
}

.paragraphList > p {
    margin-top: 35px;
    font-size: 16px;
    color: #333;
    line-height: 32px;
    text-indent: 40px;
}
.paragraphList > p > img {
    display: block;
    max-width: 100%;
    margin: 0 auto;
}
.contactUsBox {
    width: 265px;
    position: absolute;
    right: 0;
    top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/associationNewsDetail.vue